<div class="card-head pb-3 pt-2">
  <h1>{{ 'orders.Pay your order' | translate }}</h1>
</div>

<div *ngIf='loading' class="dataLoading py-5">
  <mat-spinner class="m-auto" diameter="30"></mat-spinner>
</div>
<ng-container *ngIf="!loading && validateRes?.status == 'Valid'">
  <iframe [frameBorder]="0" height="500px" width="100%"
    [src]="referencePaymentUrl | safe"></iframe>
</ng-container>
